import { render, staticRenderFns } from "./HolidayItem.vue?vue&type=template&id=683bd039&scoped=true"
import script from "./HolidayItem.vue?vue&type=script&lang=js"
export * from "./HolidayItem.vue?vue&type=script&lang=js"
import style0 from "./HolidayItem.vue?vue&type=style&index=0&id=683bd039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683bd039",
  null
  
)

export default component.exports